import { render } from "./detail-info-group.vue?vue&type=template&id=09a57666"
import script from "./detail-info-group.vue?vue&type=script&lang=js"
export * from "./detail-info-group.vue?vue&type=script&lang=js"

import "./detail-info-group.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-sold-detail/_components/detail-info-group.vue'],['render',render],['__file',"detail-info-group.vue"]])

export default __exports__